import React, { useEffect, useRef } from "react";

/**
 * Klávesové zkratky stránky (F filtr, / hledat…): jeden posluchač na document.
 * Klávesa se přeskočí v poli formuláře, s Ctrl/⌘/Alt (⌘K patří globálnímu
 * hledání) a když je otevřený dialog nebo panel.
 * mapa = { "f": () => …, "/": () => … }
 */
export function useZkratky(mapa) {
  const ref = useRef(mapa);
  ref.current = mapa;
  useEffect(() => {
    const stisk = (e) => {
      if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.altKey) return;
      const el = e.target;
      if (el && (el.isContentEditable || ["INPUT", "TEXTAREA", "SELECT"].includes(el.tagName))) return;
      if (document.querySelector('[aria-modal="true"]')) return;
      const fn = ref.current[e.key] || ref.current[e.key.toLowerCase()];
      if (!fn) return;
      e.preventDefault();
      fn(e);
    };
    document.addEventListener("keydown", stisk);
    return () => document.removeEventListener("keydown", stisk);
  }, []);
}

/** Klávesová nápověda v tlačítku — na dotykových zařízeních se neukazuje (třída kbd). */
export function Kbd({ children, tmavy = false }) {
  return (
    <span aria-hidden="true"
      className={`kbd hidden md:inline-grid place-items-center min-w-[18px] h-[18px] px-1 rounded-[4px] text-[11px] font-500 ${
        tmavy ? "bg-black/15 text-white" : "text-sec bg-inputbg border border-line"}`}>
      {children}
    </span>
  );
}
